import { useState, useEffect } from 'react';

const WhatsAppFloat = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isPulsing, setIsPulsing] = useState(true);

  useEffect(() => {
    // Show after 3 seconds
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 3000);

    // Stop pulsing after 10 seconds
    const pulseTimer = setTimeout(() => {
      setIsPulsing(false);
    }, 10000);

    return () => {
      clearTimeout(timer);
      clearTimeout(pulseTimer);
    };
  }, []);

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-6 right-6 z-50">
      <a
        href="https://wa.me/13056840894"
        target="_blank"
        rel="noopener noreferrer"
        className={`flex items-center justify-center w-16 h-16 bg-green-500 hover:bg-green-600 text-white rounded-full shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-110 ${
          isPulsing ? 'animate-pulse' : ''
        }`}
        aria-label="Contactar por WhatsApp"
      >
        <i className="ri-whatsapp-line text-2xl"></i>
      </a>
      
      {/* Tooltip */}
      <div className="absolute bottom-20 right-0 bg-black text-white text-sm px-3 py-2 rounded-lg shadow-lg opacity-0 hover:opacity-100 transition-opacity duration-200 whitespace-nowrap pointer-events-none">
        ¡Habla con un asesor ahora!
        <div className="absolute top-full right-4 w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-black"></div>
      </div>
    </div>
  );
};

export default WhatsAppFloat;